export const css = {
	welcome: '_2n_GOzgh',
	skip: '_3ZDIKSSc',
	' _key': 'apic-theme/apic/landing-page/welcome-view'
};

export default css;
